import api from '../services/api';

export const getTagId = (tag) => (typeof tag === 'object' ? tag?._id : tag);

export function hydrateArticleTags(article, tagCatalog = []) {
  if (!article || !Array.isArray(article.tags)) {
    return article;
  }

  const tagById = new Map();
  tagCatalog.forEach(tag => {
    if (tag && typeof tag === 'object' && tag._id) {
      tagById.set(String(tag._id), tag);
    }
  });

  return {
    ...article,
    tags: article.tags.map(tag => {
      const tagId = getTagId(tag);
      const knownTag = tagId ? tagById.get(String(tagId)) : null;

      if (!knownTag) {
        return tag;
      }

      if (typeof tag !== 'object') {
        return knownTag;
      }

      return {
        ...knownTag,
        ...tag,
        name: tag.name || knownTag.name,
        color: tag.color || knownTag.color
      };
    })
  };
}

// Utilitário para merge de tags sem duplicatas por _id
export function mergeTags(currentTags, newTags) {
  if (!Array.isArray(currentTags)) currentTags = [];
  if (!Array.isArray(newTags)) newTags = [];
  const merged = [
    ...currentTags,
    ...newTags.filter(
      newTag => !currentTags.some(existingTag => existingTag._id === newTag._id)
    )
  ];
  // Remove duplicatas por _id
  return merged.filter(
    (tag, idx, arr) => tag && tag._id && arr.findIndex(t => t && t._id === tag._id) === idx
  );
}

export async function fetchCurrentArticleTags(articleId) {
  const res = await api.get(`/articles/${articleId}`);
  return res.data.data.tags || [];
}
